// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
        /* Adjust the number of columns as needed */
    gap: 50px;
    margin-top: 4vw;
}

.pricing-box {
    /* width: 15%; */
    padding: 10px;
    border: 2px solid #009fe3;
    border-radius: 5px;
    /* text-align: center; */
}
.pricing-box-start {
    /* width: 20%; */
    padding: 10px;
    border: 3px solid #009fe3;
    border-radius: 5px;
    /* text-align: center; */
}
.pricing-box-start:hover{
    border: 5px solid #009fe3;
}

.pricing-box-pro {
    /* width: 20%; */
    padding: 10px;
    border: 3px solid #009fe3;
    border-radius: 5px;
    /* text-align: center; */
}
.pricing-box-pro:hover{
    border: 5px solid #009fe3;
}


.pricing-box-business {
    /* width: 20%; */
    padding: 10px;
    border: 3px solid #009fe3;
    border-radius: 5px;
    /* text-align: center; */
}
.pricing-box-business:hover{
    border: 5px solid #009fe3;
}


.pricing-box-enterprise {
    /* width: 20%; */
    padding: 10px;
    border: 3px solid #009fe3;
    border-radius: 5px;
    /* text-align: center; */
}
.pricing-box-enterprise:hover{
    border: 5px solid #009fe3;
}


.buy-now {
    text-align: center;
    padding: 0 0 20px;
}
.buy-now1 {
    text-align: center;
    /* padding: 0 0 20px; */
}
.buy-link{
    color: black;
    background-color: #f39200;
    padding: 15px 16px 13px;
    text-decoration: none;
    font-size: 12px;
    font-weight: 700;
}

.disclaimer {
    font-size: 12px;
    margin-top: 5px;
    text-align: center;
}

.features {
    margin-top: 20px;
}

.features ul {
    list-style-type: none;
    padding: 0;
}

.features li {
    margin: 5px 0;
}
.bottom-box{
    display: flex;
    justify-content: center;
    padding-top:50px;
    /* margin-bottom: 100px; */
}
.bottom-box-2{
    display: flex;
    justify-content: center;
    padding-top:0px;
    /* margin-bottom: 100px; */
}
.first-box{
    display: flex;
    /* align-items: center; */
}
.first-checkbox{
    margin-right: 10px;
    margin-top: 5px;
    color: #009640;
}
.second-checkbox {
    margin-right: 10px;
    margin-top: 4px;
    color: #009640;
}
.inside-package-box{
    margin-left: 100px;
    margin-right: 100px;
}
.boxes-second-part{
    text-align: right;
}
.p-tag{
    margin-left: 30px;
}
.htp{
    height:130px
}

@media (max-width:1250px) {
    .pricing-container{
        grid-template-columns: 2fr 2fr;
    }
    .bottom-box{
        flex-direction: column;
        justify-content: start;
    }
    .inside-package-box{
        margin-left: 200px;
        margin-right: 200px;
    }
    .boxes-second-part{
        text-align: center;
    }
    /* .buy-now1{
        padding-top:10px;
    } */
}
@media (max-width:1000px) {
    .pricing-container{
        grid-template-columns: 2fr 2fr;
    }
    .bottom-box{
        flex-direction: column;
    }
    .inside-package-box{
        margin-left: 100px;
        margin-right: 100px;
    }
}
@media (max-width:750px) {
    .pricing-container{
        grid-template-columns: 4fr;
    }
    .bottom-box{
        flex-direction: column;
    }
    .inside-package-box{
        margin-left: 100px;
        margin-right: 100px;
    }
    .boxes-second-part{
        text-align: center;
    }
    .p-tag{
        margin-left: 0px;
    }
}
@media (max-width:450px) {
 
    .inside-package-box{
        margin-left: 20px;
        margin-right: 20px;
    }
 
}
`, "",{"version":3,"sources":["webpack://./src/Price/Boxes.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;QAClC,2CAA2C;IAC/C,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;IACA;QACI,sBAAsB;QACtB,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;;OAEG;AACP;AACA;IACI;QACI,8BAA8B;IAClC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;;IAEI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;AAEJ","sourcesContent":[".pricing-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n        /* Adjust the number of columns as needed */\n    gap: 50px;\n    margin-top: 4vw;\n}\n\n.pricing-box {\n    /* width: 15%; */\n    padding: 10px;\n    border: 2px solid #009fe3;\n    border-radius: 5px;\n    /* text-align: center; */\n}\n.pricing-box-start {\n    /* width: 20%; */\n    padding: 10px;\n    border: 3px solid #009fe3;\n    border-radius: 5px;\n    /* text-align: center; */\n}\n.pricing-box-start:hover{\n    border: 5px solid #009fe3;\n}\n\n.pricing-box-pro {\n    /* width: 20%; */\n    padding: 10px;\n    border: 3px solid #009fe3;\n    border-radius: 5px;\n    /* text-align: center; */\n}\n.pricing-box-pro:hover{\n    border: 5px solid #009fe3;\n}\n\n\n.pricing-box-business {\n    /* width: 20%; */\n    padding: 10px;\n    border: 3px solid #009fe3;\n    border-radius: 5px;\n    /* text-align: center; */\n}\n.pricing-box-business:hover{\n    border: 5px solid #009fe3;\n}\n\n\n.pricing-box-enterprise {\n    /* width: 20%; */\n    padding: 10px;\n    border: 3px solid #009fe3;\n    border-radius: 5px;\n    /* text-align: center; */\n}\n.pricing-box-enterprise:hover{\n    border: 5px solid #009fe3;\n}\n\n\n.buy-now {\n    text-align: center;\n    padding: 0 0 20px;\n}\n.buy-now1 {\n    text-align: center;\n    /* padding: 0 0 20px; */\n}\n.buy-link{\n    color: black;\n    background-color: #f39200;\n    padding: 15px 16px 13px;\n    text-decoration: none;\n    font-size: 12px;\n    font-weight: 700;\n}\n\n.disclaimer {\n    font-size: 12px;\n    margin-top: 5px;\n    text-align: center;\n}\n\n.features {\n    margin-top: 20px;\n}\n\n.features ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n.features li {\n    margin: 5px 0;\n}\n.bottom-box{\n    display: flex;\n    justify-content: center;\n    padding-top:50px;\n    /* margin-bottom: 100px; */\n}\n.bottom-box-2{\n    display: flex;\n    justify-content: center;\n    padding-top:0px;\n    /* margin-bottom: 100px; */\n}\n.first-box{\n    display: flex;\n    /* align-items: center; */\n}\n.first-checkbox{\n    margin-right: 10px;\n    margin-top: 5px;\n    color: #009640;\n}\n.second-checkbox {\n    margin-right: 10px;\n    margin-top: 4px;\n    color: #009640;\n}\n.inside-package-box{\n    margin-left: 100px;\n    margin-right: 100px;\n}\n.boxes-second-part{\n    text-align: right;\n}\n.p-tag{\n    margin-left: 30px;\n}\n.htp{\n    height:130px\n}\n\n@media (max-width:1250px) {\n    .pricing-container{\n        grid-template-columns: 2fr 2fr;\n    }\n    .bottom-box{\n        flex-direction: column;\n        justify-content: start;\n    }\n    .inside-package-box{\n        margin-left: 200px;\n        margin-right: 200px;\n    }\n    .boxes-second-part{\n        text-align: center;\n    }\n    /* .buy-now1{\n        padding-top:10px;\n    } */\n}\n@media (max-width:1000px) {\n    .pricing-container{\n        grid-template-columns: 2fr 2fr;\n    }\n    .bottom-box{\n        flex-direction: column;\n    }\n    .inside-package-box{\n        margin-left: 100px;\n        margin-right: 100px;\n    }\n}\n@media (max-width:750px) {\n    .pricing-container{\n        grid-template-columns: 4fr;\n    }\n    .bottom-box{\n        flex-direction: column;\n    }\n    .inside-package-box{\n        margin-left: 100px;\n        margin-right: 100px;\n    }\n    .boxes-second-part{\n        text-align: center;\n    }\n    .p-tag{\n        margin-left: 0px;\n    }\n}\n@media (max-width:450px) {\n \n    .inside-package-box{\n        margin-left: 20px;\n        margin-right: 20px;\n    }\n \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
